import { Dispatch } from "redux";
import {
    setIdentityProvidersReferenceData,
    setIdentityProvidersReferenceDataLoading
} from "@redux/actions/identity-providers-actions";
import { getIdentityProvidersReferenceDataRequest } from "@requests/identity-provider";
import { logAndDisplayErrorModal } from "@utils/app-alert-util";
import { resources } from "@constants/hardcoded-strings";

export const getIdentityProvidersReferenceDataReduxRequest = (dispatch: Dispatch) => async () => {
    dispatch(setIdentityProvidersReferenceDataLoading(true));
    const { data, error } = await getIdentityProvidersReferenceDataRequest();
    if (data) {
        dispatch(setIdentityProvidersReferenceData(data));
    } else {
        if (error) {
            logAndDisplayErrorModal(
                dispatch,
                error,
                resources.requests.referenceData.error.title,
                resources.requests.referenceData.error.message
            );
        }
        dispatch(setIdentityProvidersReferenceDataLoading(false));
    }
};